import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { bindActionCreators, Dispatch, compose } from 'redux';
import * as loginActions from '../../modules/login/action';
import * as popupActions from '../../modules/popup/action';
import { push } from 'connected-react-router';
import { IStore } from '../../modules/root-reducer';
import ChangePassword from '../../features/change-password/change-password';

import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

import logo from './header.png';

interface IHeaderProps {
  logout: (path: string) => void;
  loggedIn: boolean;
  openChangePassword: () => void;
  openUsers: (path: string) => void;
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: {
      margin: spacing.unit
    },
    grow: {
      flexGrow: 1
    },
    buttonText: {
      color: '#FFF'
    },
    appBar: {
      background: '#000'
    },
    buttons: {
      textAlign: 'right'
    }
  });

const openUsersDispatch = (path: string) => {
  return (dispatch: Dispatch) => {
    dispatch(push(path));
    return Promise.resolve(true);
  };
};

const Header = (props: IHeaderProps & WithStyles<typeof styles>) => {
  const logout = () => {
    props.logout('/login');
  };

  const openUsers = () => {
    props.openUsers('/users');
  };

  const { classes } = props;

  return (
    <span>
      <AppBar position="static" className={classes.appBar} elevation={1}>
        <Toolbar>
          <Link to="/customers" className={classes.grow}>
            <img src={logo} className="logo" alt="logo" width="90px" />
          </Link>

          {props.loggedIn && (
            <span className={classes.buttons}>
              <Button
                color="inherit"
                onClick={openUsers}
                className={classes.buttonText}
              >
                Users
              </Button>
              <Button
                color="inherit"
                onClick={props.openChangePassword}
                className={classes.buttonText}
              >
                Change Password
              </Button>
              <Button
                color="inherit"
                onClick={logout}
                className={classes.buttonText}
              >
                Log Out
              </Button>
            </span>
          )}
        </Toolbar>
      </AppBar>
      <ChangePassword />
    </span>
  );
};

const mapStateToProps = (state: IStore) => ({
  loggedIn: state.loginReducer.loggedIn
});

const mapDispatchToProps = (
  dispatch: Dispatch<loginActions.LoginAction | popupActions.PopupAction>
) => {
  return bindActionCreators(
    {
      logout: loginActions.logout,
      openUsers: openUsersDispatch,
      openChangePassword: popupActions.openChangePassword
    },
    dispatch
  );
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
);

export default enhance(Header);



// WEBPACK FOOTER //
// ./src/common/header/header.tsx